// MAJLIS-166 (UI-C14, UI-C15, UI-C39; the consultant's rulings 2026-10-04): ONE confirmation pattern. A destructive
// action is confirmed in a sheet - the question as the sheet's title, at most one line on what goes, ONE red row (the
// row IS the confirmation, exactly as MAJLIS-163's Leave sheet), and Cancel, which sends nothing. It is the app's Sheet
// (an overlay in .sheet-layer: scrim, Escape, focus trap), so opening it never reflows the screen beneath. It replaces
// MAJLIS-80's inline confirmation block, which grew inside a sheet or under the bar and pushed everything up.
import type { ReactNode } from "react";
import { useI18n } from "../i18n";
import { Sheet } from "./Sheet";

export function ConfirmSheet({
  question,
  body,
  sub,
  action,
  hint,
  icon,
  failed,
  refused,
  busy,
  onConfirm,
  onCancel,
  spec,
}: {
  /** the question, as the sheet's title */
  question: ReactNode;
  /** an optional line on what goes (Delete record's "what is deleted") */
  body?: string;
  /** an optional muted line under the title ("You are the host") */
  sub?: ReactNode;
  /** the red row's words */
  action: string;
  /** an optional muted hint under the red row's words */
  hint?: string;
  icon?: ReactNode;
  /** the action was sent and failed: the existing "could not" line, the sheet stays */
  failed?: ReactNode;
  /** MAJLIS-176 (the admin mock-up (d)): the server REFUSED the action for a reason the person can act on later (a room
   * still open): its line under the red row, in --warn; the sheet stays */
  refused?: ReactNode;
  /** the action is on its way: the red row is disabled */
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  spec: string;
}) {
  const { t } = useI18n();
  return (
    <Sheet title={question} sub={sub} onClose={onCancel} spec={spec}>
      <div className="leave-choices confirm-sheet">
        {body && <p className="confirm-body">{body}</p>}
        {failed && (
          <p className="sheet-failed" role="alert">
            {failed}
          </p>
        )}
        <button
          type="button"
          className="sheet-choice danger-row confirm-yes"
          disabled={busy}
          onClick={onConfirm}
          data-spec={spec}
        >
          {icon}
          <span className="row-text">
            <span>{action}</span>
            {hint && <span className="row-hint">{hint}</span>}
          </span>
        </button>
        {refused && (
          <p className="sheet-refused" role="alert">
            {refused}
          </p>
        )}
        <button type="button" className="text-link leave-cancel confirm-cancel" onClick={onCancel}>
          {t("cancel")}
        </button>
      </div>
    </Sheet>
  );
}
